import { Flex } from "@chakra-ui/layout";
import { Box, Text } from "@chakra-ui/react";
import { ProcuracaoDetalhe } from "core/features/assembleia/typings/procuracao";
import colors from "core/resources/theme/colors";
import { useState } from "react";
import OutlineButton from "ui/components/Button/OutlineButton";
import ModalProcuracao from "./ModalProcuracao";

interface DocumentosProps {
  procuracao: ProcuracaoDetalhe;
}

function Documentos({ procuracao }: DocumentosProps) {
  const [modalProcuracaoVisible, setModalProcuracaoVisible] = useState(false);
  return (
    <Flex flexDir="column">
      <Text fontSize={20} mb={4}>
        Documentos
      </Text>
      <Box mb={4}>
        <DocumentoItem
          titulo="Procuração"
          onSee={() => setModalProcuracaoVisible(true)}
        />
      </Box>
      <Box mb={4}>
        <DocumentoItem
          titulo="Assinatura do Solicitante"
          onSee={() =>
            window.open(procuracao.assinaturaArquivo.referencia, "_blank")
          }
        />
      </Box>

      <ModalProcuracao
        visible={modalProcuracaoVisible}
        onClose={() => setModalProcuracaoVisible(false)}
        procuracao={procuracao}
      />
    </Flex>
  );
}

const DocumentoItem = ({
  titulo,
  onSee,
}: {
  titulo: string;
  onSee: () => any;
}) => (
  <Flex
    borderLeftWidth={4}
    borderLeftColor={colors.blueishGray50}
    pl={4}
    justifyContent="space-between"
    w="100%"
    alignItems="center"
  >
    <Text fontSize={14} color={colors.black}>
      {titulo}
    </Text>
    <OutlineButton onClick={onSee} h="28px">
      Ver
    </OutlineButton>
  </Flex>
);

export default Documentos;
